import { IconButton, Stack, Tooltip, Typography } from "@mui/material";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import { Translations } from "../localization/translations";
import { format } from "date-fns";

interface IFile {
    id: number;
    fileName: string;
    fileExtension: string;
    createdAt: Date;
}

interface IFileListProps {
    title: string;
    files: IFile[];
    onDownaloadClick: (file: IFile) => void;
    showFileDate: boolean;
}

const FileList: React.FC<IFileListProps> = ({
    title,
    files,
    onDownaloadClick,
    showFileDate
}) => {
    const { t } = useTranslation();

    return (
        <Stack>
            <Typography variant="caption" color="text.secondary">
                {title}
            </Typography>
            {files.map((file) => (
                <>
                    <Stack
                        key={file.id}
                        direction="row"
                        alignItems="center"
                        spacing={1}
                    >
                        <AttachFileIcon color="primary" />
                        <Typography color="primary">{file.fileName}</Typography>
                        <Tooltip
                            title={t(Translations.common.tooltip.downloadFile)}
                        >
                            <IconButton onClick={() => onDownaloadClick(file)}>
                                <DownloadIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    {file.createdAt && showFileDate &&
                        <Typography variant="caption" color="text.secondary">
                            {`${t(
                                Translations.classifier.label.fileDate
                            )}: ${format(
                                new Date(file.createdAt),
                                t(Translations.formats.date.text)
                            )}`}
                        </Typography>
                    }
                </>
            ))}
        </Stack>
    );
};

export default FileList;
